module.exports = __webpack_public_path__ + "static/media/LogoArtlingProjectsBeta.037eb3ea.svg";